export default __webpack_public_path__ + "static/media/MBChurchill.123709dc.png";